import { Action, combineReducers } from '@ngrx/store';
import { objDiff } from '../utility';

import {
  _CLEAR,
  GET_HOLDBINS,
  UPDATE_HOLDBIN,
  SET_HOLDBINS_VIEW,
  CREATE_HOLDBIN
} from '../actions';

const initialHoldBinsViewState = {
  loading: <boolean>false
};

export function holdBinListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    // case CREATE_QABIN:
    //   const match = state.find(qabin => action.payload.qabin && qabin.id === action.payload.qabin.id);
    //   return !match
    //     ? [ ...state, action.payload.qabin ]
    //     : state;
    // case CLEAR_QABIN:
    //   return state.map(bin => {
    //     const updatedBin = Object.assign({}, bin);

    //     if (bin.shipmentID === action.payload.shipment.id) {
    //       updatedBin.orderID = null;
    //       updatedBin.shipmentID = null;
    //     }

    //     return updatedBin;
    //   });
    case GET_HOLDBINS:
      return [ ...action.payload.holdbins ].sort(sortBins);
    case UPDATE_HOLDBIN:
      return state.map(holdbin => {
        return holdbin.id === action.payload.id
          ? objDiff(holdbin, action.payload.diffList)
          : holdbin;
      });
    default:
      return state;
  }
}

export function holdBinsViewReducer(state = initialHoldBinsViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialHoldBinsViewState);
    case SET_HOLDBINS_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

function sortBins(bin1: any, bin2: any) {
  return +bin1.binNumber - +bin2.binNumber;
}

export const holdBinsReducers = combineReducers({
  holdBinList   : holdBinListReducer,
  holdBinsView  : holdBinsViewReducer
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/holdBins.ts